import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { SegmentTrackEvent } from '@ninety/platform/models/analytics/segment/segment-track-event.enum';

import { SegmentActions } from '../analytics/segment/segment.actions';

import { UserActivityActions } from './user-activity.actions';

@Injectable()
export class UserActivityAnalyticsEffects {
  private readonly actions$ = inject(Actions);

  /** Inactivity reload prompt shown — hoursInactive = total inactivity (1-decimal) when it opened. */
  trackPromptOpened$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActivityActions.inactivityReloadPromptOpened),
      map(({ hoursInactive }) =>
        SegmentActions.track({
          event: SegmentTrackEvent.INACTIVITY_RELOAD_PROMPT_OPENED,
          params: { hoursInactive },
        })
      )
    )
  );

  /** Which choice the user made — one event with a `choice` dimension ('reload' | 'not_now') so
   *  the reload-vs-dismiss split is a single breakdown in Gainsight PX. */
  trackPromptChoice$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActivityActions.inactivityReloadPromptClosed),
      map(({ hoursInactive, shouldReload }) =>
        SegmentActions.track({
          event: SegmentTrackEvent.INACTIVITY_RELOAD_PROMPT_RESPONDED,
          params: { hoursInactive, choice: shouldReload ? 'reload' : 'not_now' },
        })
      )
    )
  );
}
